/// <reference path="PaymentEntityCell.ts" />


class AdyenPaymentEntityCell extends PaymentEntityCell
{
    private infoButton:MUIButton = null;

    // The onboarding state, shown and never edited: the sign-up and the Adyen
    // webhooks are what move it.
    private statusLabel:MUILabel = null;
    private statusIcon:MUIView = null;

    awakeFromHTML(){
        super.awakeFromHTML();

        this.infoButton = MUIOutlet(this, "info-btn", "MUIButton");
        this.infoButton.setAction(this, this.infoAction );

        this.statusLabel = MUIOutlet(this, "status-lbl", "MUILabel");
        this.statusIcon = MUIOutlet(this, "status-dot-icon", "MUIView");
    }

    setItem(item:PaymentEntity){
        super.setItem(item);
        this.updateStatusUI(item);
    }

    private updateStatusUI(item:PaymentEntity){
        let color = item.status == PaymentEntityStatus.ready ? "green"
                  : item.status == PaymentEntityStatus.error ? "red"
                  :                                            "yellow";

        for (let view of [ this.statusLabel, this.statusIcon ]) {
            if (view == null) continue;
            for (let style of ["green", "yellow", "red"]) MUICoreLayerRemoveStyle( view.layer, style );
            MUICoreLayerAddStyle( view.layer, color );
        }

        if (this.statusLabel) this.statusLabel.text = PaymentEntity.statusStringForStatus(item.status);
    }

    private infoAction()
    {
        let vc = AdyenDetailViewController.newInstance();
        vc.paymentEntity = this._item as AdyenPaymentEntity;
        AppHelper.sharedInstance().presentViewController(vc, true);
    }

}
